import React, { useEffect, useState } from "react";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverAssetsActions from "../../../store/actions/DriverAssets";
import * as UserActions from "../../../store/actions/User";
import { getReadableDateTime } from "../../../utils";
import AvailableAssetsTable from "../AvailableAssetsTable";
import OnboardingCenterInputBar from "../OnboardingCenterInputBar";
import SuccessMessages from "../../../constants/SucessMessages.json";
import OtpDialog from "../OtpDialog";
import PaymentModal from "../PaymentModal";
import Permission from "../../../components/Common/Permission";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import NoFooterModal from "../../Common/NoFooterModal";
import { BottomSectionModal } from "../../../constants/assets/containers";

const AddAssetsModal = (props) => {
  const {
    modalState,
    handleClose,
    transactionStatus,
    getDriverAssetsAvailableList,
    addDriverAssets,
    driverAssetsAvailableList,
    recentAssetStatus,
    driverId,
    discardAsset,
    setStatus,
    getTransactionStatus,
    checkPaymentStatus,
  } = props;
  const [assetId, setAssetId] = useState(""); //added asset id
  const [total, setTotal] = useState(0);
  const [error, setError] = useState({});
  const [modalAction, setModalAction] = useState("");
  const [assets, setAssets] = useState({});
  const [centerId, setCenterId] = useState(""); //selected onboarding center id
  const [assetStatus, setAssetStatus] = useState(""); //transaction status
  const allActions = MenuActionsMappings[MenuNames.DRIVER_ASSETS];

  useEffect(() => {
    if (driverId) {
      const date = new Date();
      const formattedDate = date.toISOString();
      getDriverAssetsAvailableList({
        driver_id: driverId,
        date: formattedDate,
      });
    }
  }, [driverId]);

  //get content based on transaction status
  const getModalContent = () => {
    switch (transactionStatus) {
      case "COMPLETED":
      case "FAILED":
      case "ADDED":
        return (
          <>
            <OnboardingCenterInputBar
              error={error}
              setError={setError}
              centerId={centerId}
              setCenterId={setCenterId}
              driverId={driverId}
            />
            {error.assets && (
              <div className="error-state">{"*" + error.assets}</div>
            )}
            <AvailableAssetsTable
              total={total}
              setTotal={setTotal}
              assets={assets}
              setError={setError}
              setAssets={setAssets}
              transactionStatus={transactionStatus}
              driverAssetsAvailableList={driverAssetsAvailableList}
              driverId={driverId}
            />
          </>
        );
      case "VERIFIED":
        return (
          <>
            <h3>{`Your recent pending asset transaction on ${getReadableDateTime(
              recentAssetStatus.updated_at
            )}`}</h3>
            <AvailableAssetsTable
              total={total}
              setTotal={setTotal}
              transactionStatus={transactionStatus}
              assetInfo={recentAssetStatus.info}
              assets={assets}
              setError={setError}
              setAssets={setAssets}
              driverAssetsAvailableList={driverAssetsAvailableList}
              driverId={driverId}
            />
            {assetStatus && (
              <p className="asset-status text-black pt-20">{assetStatus}</p>
            )}
          </>
        );
      default:
        return (
          <>
            <OnboardingCenterInputBar
              error={error}
              setError={setError}
              centerId={centerId}
              setCenterId={setCenterId}
              driverId={driverId}
            />
            {error.assets && (
              <div className="error-state">{"*" + error.assets}</div>
            )}
            <AvailableAssetsTable
              setError={setError}
              total={total}
              setTotal={setTotal}
              assets={assets}
              setAssets={setAssets}
              transactionStatus={transactionStatus}
              driverAssetsAvailableList={driverAssetsAvailableList}
              driverId={driverId}
            />
          </>
        );
    }
  };

  const checkTransactionStatus = () => {
    checkPaymentStatus({
      transaction_id: parseInt(recentAssetStatus.transaction_id),
    }).then((res) => {
      if (res) {
        getTransactionStatus({
          transaction_id: recentAssetStatus.transaction_id,
        }).then((res) => {
          if (res && res.transaction_status.status === "COMPLETE") {
            handleClose();
            props.getDriverAssetsIssuedList({ driver_id: driverId });
          } else {
            setAssetStatus(
              "Payment is not successful or not initiated, Please discard the asset and add again"
            );
          }
        });
      }
    });
  };

  const handleDiscardAsset = () => {
    const payload = {
      message: "discarded",
      asset_id: recentAssetStatus.id,
    };
    discardAsset(payload).then((res) => {
      if (res) {
        setStatus({
          type: "success",
          message: SuccessMessages.ASSET_DISCARDED,
        });
        handleClose();
      }
    });
  };

  const handleOtpButtonClick = () => {
    //handle errors
    let err = { ...error };
    if (!centerId) {
      err["center"] = "Please select onboarding center";
    } else if (Object.keys(assets).length === 0) {
      err["assets"] = "Please select atleast one item";
    } else {
      let info = { ...assets };
      Object.keys(info).map((asset) => {
        info[asset]["quantity"] = parseInt(info[asset]["quantity"]);
        if (info[asset]["size"] <= 0 && info[asset]["quantity"] > 0) {
          if (info[asset]["size"] === -1) {
            err["assets"] = "Please select asset size";
            return;
          }
          delete info[asset]["size"];
        }
        if (info[asset]["quantity"] <= 0) {
          delete info[asset];
        }
      });
      if (Object.keys(err).length === 0) {
        const payload = {
          info: info,
          driver_id: driverId,
          onboarding_center_id: centerId + "",
        };
        if (transactionStatus === "ADDED") {
          payload["assets_issuance_id"] = recentAssetStatus.id;
        }
        const endpoint = transactionStatus === "ADDED" ? "modify" : "create";
        addDriverAssets(payload, endpoint).then((res) => {
          if (res) {
            setModalAction("otp");
            setAssetId(res.asset_id);
          }
        });
      }
    }
    setError(err);
  };

  const getButtons = () => {
    switch (transactionStatus) {
      case "VERIFIED":
        return (
          <>
            <Permission
              requiredPerms={[allActions.ISSUANCE, allActions.ISSUANCE_LIST]}
            >
              <Button
                data-testid="checkStatusButton"
                onClick={checkTransactionStatus}
                className="sushi-btn"
              >
                CHECK STATUS
              </Button>
            </Permission>
            <Permission requiredPerms={[allActions.ISSUANCE]}>
              <Button
                data-testid="discardButton"
                onClick={handleDiscardAsset}
                className="sushi-btn"
              >
                DISCARD ASSET
              </Button>
            </Permission>
          </>
        );
      default:
        return (
          <>
            <Button
              data-testid="cancelButton"
              onClick={handleClose}
              className="sushi-btn"
            >
              CANCEL
            </Button>
            <Permission requiredPerms={[allActions.ISSUANCE]}>
              <Button
                data-testid="submitOTPButton"
                className="sushi-btn"
                onClick={handleOtpButtonClick}
              >
                ADD & SEND OTP
              </Button>
            </Permission>
          </>
        );
    }
  };

  const getDialog = () => {
    if (modalAction === "otp") {
      return (
        <OtpDialog
          setModalAction={setModalAction}
          assetId={assetId}
          isVisible={modalAction === "otp"}
          handleReject={handleClose}
        />
      );
    } else if (modalAction === "payment") {
      return (
        <PaymentModal
          handleClose={handleClose}
          amount={total}
          assetId={assetId}
          driverId={driverId}
          isVisible={modalAction === "payment"}
        />
      );
    } else {
      return (
        <NoFooterModal
          header={true}
          open={!!modalState}
          heading="Add Assets"
          handleClose={handleClose}
          id="driverAddAssetsModal"
          modalButtons={
            <BottomSectionModal className="flex items-center justify-between">
              {getButtons()}
            </BottomSectionModal>
          }
        >
          {getModalContent()}
        </NoFooterModal>
      );
    }
  };

  return getDialog();
};

function mapStateToProps(state) {
  const { DriverAssets } = state;
  return {
    recentAssetStatus: DriverAssets.recentAssetStatus,
    driverAssetsAvailableList: DriverAssets.driverAssetsAvailableList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverAssetsIssuedList: bindActionCreators(
      DriverAssetsActions.getDriverAssetsIssuedList,
      dispatch
    ),
    resetState: bindActionCreators(DriverAssetsActions.resetState, dispatch),
    getRecentAssetStatus: bindActionCreators(
      DriverAssetsActions.getRecentAssetStatus,
      dispatch
    ),
    getDriverAssetsAvailableList: bindActionCreators(
      DriverAssetsActions.getDriverAssetsAvailableList,
      dispatch
    ),
    discardAsset: bindActionCreators(
      DriverAssetsActions.discardAsset,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    addDriverAssets: bindActionCreators(
      DriverAssetsActions.addDriverAssets,
      dispatch
    ),
    verifyAssetsOtp: bindActionCreators(
      DriverAssetsActions.verifyOtp,
      dispatch
    ),
    getTransactionStatus: bindActionCreators(
      DriverAssetsActions.getTransactionStatus,
      dispatch
    ),
    checkPaymentStatus: bindActionCreators(
      DriverAssetsActions.checkPaymentStatus,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAssetsModal);
